@if (preCardTitle) {
	<div class="pre-card-title">
		@if (icon) {
			<button mat-icon-button
					[disabled]="iconDisabled"
					(click)="iconClicked.emit()">
				<mat-icon>{{ icon }}</mat-icon>
			</button>
		}
		<h2>{{ preCardTitle }}</h2>
	</div>
}

<mat-card class="my-8 card">
	@for (c of content; track c.templateRef) {
        @if(!c.needsMargin) {
			@if ($first && inCardTitle) {
				<mat-card-actions class="in-card-title">
          <div class="flex-row align-items-center">
            @if (icon) {
              <button mat-icon-button
                      [disabled]="iconDisabled"
                      (click)="iconClicked.emit()"
                      [matTooltip]="iconTooltip"
              >
                <mat-icon>{{ icon }}</mat-icon>
              </button>
            }
            <h2>{{ inCardTitle }}</h2>
          </div>
          <div>
            @if (actionIcon) {
              <button mat-icon-button
                      [disabled]="actionIconDisabled"
                      (click)="actionIconClicked.emit()"
                      [matTooltip]="actionTooltip"
              >
                <mat-icon>{{ actionIcon }}</mat-icon>
              </button>
            }
            @if (action2Icon) {
              <button mat-icon-button
                      [disabled]="action2IconDisabled"
                      (click)="action2IconClicked.emit()"
                      [matTooltip]="action2Tooltip"
              >
                <mat-icon>{{ action2Icon }}</mat-icon>
              </button>
            }
          </div>
				</mat-card-actions>
			}
			<ng-container [ngTemplateOutlet]="c.templateRef"></ng-container>
		} @else {
			@if ($first && inCardTitle) {
				<mat-card-actions class="in-card-title">
          <div class="flex-row align-items-center">
            @if (icon) {
              <button mat-icon-button
                  [disabled]="iconDisabled"
                  (click)="iconClicked.emit()"
                  [matTooltip]="iconTooltip"
              >
                <mat-icon>{{ icon }}</mat-icon>
              </button>
            }
            <h2>{{ inCardTitle }}</h2>
          </div>
          <div>
            @if (actionIcon) {
              <button mat-icon-button
                      [disabled]="actionIconDisabled"
                      (click)="actionIconClicked.emit()"
                      [matTooltip]="actionTooltip"
              >
                <mat-icon>{{ actionIcon }}</mat-icon>
              </button>
            }
            @if (action2Icon) {
              <button mat-icon-button
                      [disabled]="action2IconDisabled"
                      (click)="action2IconClicked.emit()"
                      [matTooltip]="action2Tooltip"
              >
                <mat-icon>{{ action2Icon }}</mat-icon>
              </button>
            }
          </div>
				</mat-card-actions>
			}
			<mat-card-content>
            	<ng-container [ngTemplateOutlet]="c.templateRef"></ng-container>
        	</mat-card-content>
		}
        @if (!$last) {
          <mat-divider></mat-divider>
        }
    }
</mat-card>
